import { RestApiClient } from 'ifield-core-components'

export default {
  namespaced: true,
  state: {
    id: null,
    roleId: null,
    groups: [],
  },
  mutations: {
    /**
     * stateを初期化する
     * @param {*} state
     */
    resetState(state) {
      state.id = null
      state.roleId = null
      state.groups = []
    },
    /**
     * 対象ユーザーのユーザーID,ロールID,所属組織を設定する
     * @param {*} state
     * @param {Array.<String>} targets 検索項目
     */
    setState(state, data) {
      state.id = data.id
      state.roleId = data.role_id
      state.groups = data.groups
    },
  },
  getters: {
    /**
     * ユーザーID
     * @param {*} state
     * @returns {String}
     */
    id: (state) => state.id,
    /**
     * ユーザーロールID
     * @param {*} state
     * @returns
     */
    roleId: (state) => state.roleId,
    /**
     * 所属組織
     * @param {*} state
     * @returns
     */
    groups: (state) => state.groups,
    /**
     * デフォルト組織
     * @param {*} state
     * @returns
     */
    defaultOrganizationId: (state) => {
      if (!state.groups.length) return null

      const defaultOrganization = state.groups.find(
        (group) => group.default_organization
      )
      return defaultOrganization ? defaultOrganization.id : state.groups[0].id
    },
  },
  actions: {
    /**
     * stateをリセットする
     */
    resetState({ commit }) {
      commit('resetState')
    },
    /**
     * ログインユーザーの詳細データ更新
     */
    async updateUserProfile({ commit, rootGetters }) {
      const url = RestApiClient.createApiUrl(
        `user/${rootGetters.loginState.userId}`
      )
      const json = await RestApiClient.executeGetApi(url)
      commit('setState', json.data)
    },
  },
}
